import Reusable from '../Page/Reusable';

export default Reusable;
